import { Dispatch, SetStateAction } from "react";
import {
  getUsersAvailable,
  putUsersAvailable,
} from "services/notificationsServices";

type NotificationData = {
  description: string;
  id: string;
};

type NotificationDataResponse = {
  createDate: string;
  isDone: boolean;
  isShouldNotify: boolean;
  nextNotificationTime: string;
  notification: NotificationData;
  updateDate: string;
};

export const getAvailable = async (
  setNotificationId: Dispatch<SetStateAction<string | null>>
): Promise<boolean> => {
  const response: NotificationDataResponse[] = await getUsersAvailable();
  const notificationResponse = response.find(
    (resp) => resp.notification.description === "Pesquisa de Usabilidade"
  );

  setNotificationId(notificationResponse?.notification?.id || null);
  return notificationResponse?.isShouldNotify || false;
};

export const updateNotification = async (
  notificationId: string
): Promise<void> => {
  await putUsersAvailable(notificationId);
};
